import { HelpTip } from './types';

export const STRUCTURE_TIPS = {
  groupsTable: {
    title: { fr: 'Les groupes', en: 'Groups' },
    text: {
      fr: "Un groupe est le niveau le plus haut de l'organisation d'un client : il regroupe une ou plusieurs sociétés, qui possèdent elles-mêmes des exploitations. C'est au niveau du groupe que se règlent l'utilisation (distributeur / exploitant), la marque blanche, les points d’inspection et le rapport d'inspection.",
      en: "A group is the highest level of a customer's organisation: it gathers one or several companies, which own branches. The usage (distributor / operator), white label, check points and inspection report are configured at group level.",
    },
    docSlug: 'les-groupes',
  },
  companiesColumn: {
    title: { fr: 'Sociétés du groupe', en: 'Companies of the group' },
    text: {
      fr: 'Nombre de sociétés rattachées à ce groupe. Lorsque le nombre est supérieur à zéro, la flèche ouvre la liste de ces sociétés.',
      en: 'Number of companies linked to this group. When the number is greater than zero, the arrow opens the list of these companies.',
    },
    docSlug: 'les-societes',
  },
  branchesColumn: {
    title: { fr: 'Exploitations', en: 'Branches' },
    text: {
      fr: "Nombre total d'exploitations (agences, sites, garages…) rattachées aux sociétés de cette ligne. La flèche ouvre directement la liste filtrée.",
      en: 'Total number of branches (agencies, sites, garages…) linked to the companies of this row. The arrow opens the filtered list.',
    },
    docSlug: 'les-exploitations',
  },
  usageColumn: {
    title: { fr: 'Utilisation', en: 'Usage' },
    text: {
      fr: "Rôle de la structure dans l'écosystème : distributeur (revend la solution à d'autres groupes), exploitant (inspecte ses propres véhicules) ou les deux. Chaque utilisation est affichée avec son icône : boutique bleue pour Distributeur, usine verte pour Exploitation.",
      en: 'Role of the structure in the ecosystem: distributor (resells the solution to other groups), operator (inspects its own vehicles) or both. Each usage is shown with its icon: blue shop for Distributor, green factory for Branch.',
    },
    docSlug: 'usages-distributeur-exploitant',
  },
  whiteLabelColumn: {
    title: { fr: 'Marque blanche', en: 'White label' },
    text: {
      fr: "Lorsque la marque blanche est active, les emails, rapports et l'application d'inspection affichent le logo et les informations du client à la place de celles de Lucius.",
      en: "When the white label is active, emails, reports and the inspection app display the customer's logo and details instead of Lucius ones.",
    },
    docSlug: 'marque-blanche',
  },
  companiesTable: {
    title: { fr: 'Les sociétés', en: 'Companies' },
    text: {
      fr: "Une société appartient à un groupe et possède des exploitations. Une société ne peut pas être désactivée tant que des exploitations lui sont rattachées : lors d'une désactivation multiple, ces sociétés sont ignorées.",
      en: 'A company belongs to a group and owns branches. A company cannot be deactivated while branches are linked to it: during a bulk deactivation, these companies are skipped.',
    },
    docSlug: 'liste-des-societes',
  },
  companyBranchesColumn: {
    title: { fr: 'Exploitations de la société', en: 'Branches of the company' },
    text: {
      fr: "Nombre d'exploitations rattachées à cette société. Lorsque le nombre est supérieur à zéro, la flèche ouvre la liste de ces exploitations.",
      en: 'Number of branches linked to this company. When the number is greater than zero, the arrow opens the list of these branches.',
    },
    docSlug: 'les-exploitations',
  },
  inheritedUsageColumn: {
    title: { fr: 'Utilisation (du groupe)', en: 'Usage (of the group)' },
    text: {
      fr: "L'utilisation affichée est celle du groupe auquel la structure est rattachée : distributeur (revend la solution à d'autres groupes), exploitant (inspecte ses propres véhicules) ou les deux. Elle se modifie depuis la fiche du groupe.",
      en: 'The usage displayed is the one of the group the structure belongs to: distributor (resells the solution to other groups), operator (inspects its own vehicles) or both. It is changed from the group form.',
    },
    docSlug: 'usages-distributeur-exploitant',
  },
  inheritedWhiteLabelColumn: {
    title: {
      fr: 'Marque blanche (du groupe)',
      en: 'White label (of the group)',
    },
    text: {
      fr: "Indique si la marque blanche est active sur le groupe auquel la structure est rattachée. Elle s'active depuis la fiche du groupe ; lorsqu'elle est active, un onglet supplémentaire permet de personnaliser les textes dans la fiche de la société ou de l'exploitation.",
      en: 'Shows whether the white label is active on the group the structure belongs to. It is enabled from the group form; when active, an extra tab lets you customise the texts in the company or branch form.',
    },
    docSlug: 'marque-blanche',
  },
  branchesTable: {
    title: { fr: 'Les exploitations', en: 'Branches' },
    text: {
      fr: "Une exploitation (agence, site, garage…) est rattachée à une société, elle-même rattachée à un groupe. C'est le niveau le plus fin de l'organisation d'un client.",
      en: "A branch (agency, site, garage…) is linked to a company, itself linked to a group. It is the finest level of a customer's organisation.",
    },
    docSlug: 'liste-des-exploitations',
  },
} satisfies Record<string, HelpTip>;
